import gql from 'graphql-tag'

export const GET_NOTES_LIST = gql`
  query {
    notesList @client {
      compositionIds,
      patientNoteIds
    }
  }
`

export const SET_NOTES_LIST = gql`
  mutation setNotesList($compositionIds: [String], $patientNoteIds: [String]) {
    setNotesList(compositionIds: $compositionIds, patientNoteIds: $patientNoteIds) @client
  }
`
